module.exports = __webpack_public_path__ + "static/media/NewSearch.720dcbdb.svg";